<template>
  <div class="device_power">
    <div class="power_box">
      <img src="@/assets/img/power.svg" class="power_icon" :class="{ no_power: data.power == 0 }" />
      <div class="power_bg" :class="{ no_power_bg: data.power == 0 }" :style="powerFillStyle"></div>
      <img v-if="data.isCharging" src="@/assets/img/low_battery.svg" class="low_battery" />
    </div>
    <p class="power_num" v-if="specialCheckCurrent(speciaBehiver.WiredShowChargingAndPower) || !specialCheckCurrent(speciaBehiver.SpecialEquipment_WiredCharging)" :class="{ no_power_num: data.power == 0 }">{{ data.power || 0 }}%</p>

    <div class="device_power_massage" v-if="data.amberMouseGetPowerCount == 1 && data.power == 0">
      {{ $t('power_message') }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, toRef } from 'vue'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import { powerSet } from '@/service/driver/power_set'
const data = toRef(powerSet.state)
const powerFillStyle = computed(() => {
  const ratio = Math.max(0, Math.min(1, (data.value.power || 0) / 100))
  return {
    transform: `scaleX(${ratio})`,
  }
})

onMounted(() => {
  powerSet.getPowerData()
})
</script>

<style scoped lang="less">
.device_power {
  --power-icon-width: 46px;
  --power-icon-height: 24px;
  --power-fill-width: 32px;
  --power-fill-height: 14px;
  --power-fill-left: 6px;
  --power-low-battery-left: 19px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  &:hover {
    .device_power_massage {
      display: flex;
    }
  }

  .power_num {
    font-size: 14px;
    color: var(--power-text-color, var(--color-white));
    margin-right: 0;
    min-width: 38px;
    text-align: left;
    font-weight: 700;
  }

  .no_power_num {
    color: var(--power-empty-text-color, #ff3333);
  }

  .power_box {
    position: relative;
    display: flex;
    align-items: center;

    .power_icon {
      width: var(--power-icon-width);
      height: var(--power-icon-height);
    }

    .no_power {
      filter: brightness(0) saturate(100%) invert(33%) sepia(100%) saturate(7473%) hue-rotate(330deg) brightness(91%) contrast(107%);
    }

    .power_bg {
      position: absolute;
      background-color: var(--power-fill-color, var(--color-white));
      width: var(--power-fill-width);
      height: var(--power-fill-height);
      left: var(--power-fill-left);
      border-radius: 2px;
      transform-origin: left center;
    }

    .no_power_bg {
      background-color: var(--power-empty-fill-color, #ff3333);
    }

    .low_battery {
      position: absolute;
      left: var(--power-low-battery-left);
    }
  }

  .device_power_massage {
    position: absolute;
    top: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
    padding: 10px 12px;
    color: var(--power-message-text-color, var(--color-text-hint));
    font-size: 12px;
    text-wrap: nowrap;
    white-space: nowrap;
    display: none;
    background-color: var(--power-message-bg, var(--color-white));
    border-radius: var(--radius-s);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
    z-index: 1000;
  }
}
</style>
